import { useQuery } from '@tanstack/react-query';
import { getStepItems, type CanonicalProcessName } from '../processes.api';
import type { ProcessFilterValues } from '../procesLijsten';

/**
 * Server-state for the stap-detailscherm (Story 3.4). `name`/`step` outside the canonical whitelist never fires the query.
 * `kolommen` (spec-tabelfilters story 8): kolomfilters, sortering en facetten als queryparameters.
 */
export function useStepItems(name: CanonicalProcessName | null, step: string | null, filters: ProcessFilterValues = {}, page = 1, kolommen?: Record<string, string>) {
  return useQuery({
    queryKey: ['processes', 'stepItems', name, step, filters, page, kolommen ?? null],
    queryFn: () => getStepItems(name as CanonicalProcessName, step as string, { filters, page, kolommen }),
    enabled: name != null && step != null,
    // Bij filteren en bladeren de vorige rijen laten staan (anders verdwijnt de filterbalk met de focus erin),
    // maar nooit die van een andere stap onder de kop van deze.
    placeholderData: (prev, prevQuery) => (prevQuery?.queryKey[2] === name && prevQuery?.queryKey[3] === step ? prev : undefined),
    staleTime: 30 * 1000,
  });
}
